import styled from "styled-components";

export const Container = styled.div`
    svg {
        font-size: ${globalThis.config.fonts.sizes.xsmall};
    }
    ${(props) =>
        props.border &&
        `
        border: ${globalThis.config.border.small};
    `}
    width:100%;
    height: 100%;
    border-radius: 0.1875rem;
    &:hover {
        border: ${globalThis.config.border.smallBlack};
    }
`;

export const Trigger = styled.div`
    cursor: pointer;
    padding: 0.5rem;
    display: inline-flex;
    align-items: center;
    border-radius: 0.1875rem;
    height: 100%;
    ${(props) =>
        props.width &&
        `
        width: ${props.width};
    `}

    & > p {
        width: 93%;
        align-self: center;
    }
`;

export const SelectedLabel = styled.span`
    > span {
        color: ${globalThis.config.colors.gray2};
    }
    width: 81%;
    font-size: ${globalThis.config.fonts.sizes.smedium};
    display: flex;
    align-items: center;
`;

export const DownCaretWrapper = styled.div`
    display: inline-flex;
    align-items: center;
    overflow: hidden;
`;

export const MenuItemLabel = styled.div`
    width: 100%;
`;
